//
//
//
//
//
//
//
//
//
//

export default {
  name: "AppMain",
  computed: {
    cachedViews: function cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    useCache: function useCache() {
      return this.$store.state.settings.useCache;
    },
    key: function key() {
      return this.$route.path;
    }
  }
};